import { render, staticRenderFns } from "./AgenSort.vue?vue&type=template&id=4c0d369e&"
import script from "./AgenSort.vue?vue&type=script&lang=js&"
export * from "./AgenSort.vue?vue&type=script&lang=js&"
import style0 from "./AgenSort.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports